"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IframeWidget_1 = __importDefault(require("../../../../utils/fabric/Widgets/Iframe/IframeWidget"));
var elementStyles_1 = require("./elementStyles");
var IframeElement = function (_a) {
    var object = _a.object;
    var cId = object.cId, cIframeProps = object.cIframeProps;
    if (cIframeProps === undefined) {
        // temporary fix for old iframe elements that does not have cIframeProps
        return react_1.default.createElement("div", { key: cId });
    }
    return (react_1.default.createElement("div", { key: cId, style: __assign(__assign({}, (0, elementStyles_1.generateElementContainerStyle)(object)), { overflow: 'hidden' // otherwise crop with top: -100px for example does not work.
         }) },
        react_1.default.createElement(IframeWidget_1.default, { iframeProps: cIframeProps })));
};
exports.default = IframeElement;
//# sourceMappingURL=IframeElement.js.map